import { AssigneeType } from 'api/clients/PropertyClient'
import { ArticlePostPreviewActionTypes, useArticlePostPreviewContext } from '../ArticlePostPreviewContext'
import { usePostProperties } from '../usePostProperties'
import Styles from './MobilePostPreviewFooter.module.scss'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Button } from 'blaze-ui/Button'

export const MobilePostPreviewFooter = () => {
  const {
    state: { loading, newCopy, content },
    almanacFile,
    persistChanges,
    dispatch,
  } = useArticlePostPreviewContext()

  const { postAt } = usePostProperties({
    id: almanacFile.id,
    type: AssigneeType.Article,
  })

  const [localPostAt, setLocalPostAt] = useState(postAt)
  if (!loading) {
    if (postAt && !localPostAt) {
      setLocalPostAt(postAt)
    } else if (!postAt && !localPostAt) {
      setLocalPostAt(dayjs().hour(12).minute(0).toISOString())
    }
  }
  useEffect(() => {
    if (!postAt) {
      setLocalPostAt(undefined)
    }
  }, [postAt])

  if (loading) return null

  return (
    <div className={Styles.container}>
      <Button
        size="lg"
        isDisabled={!newCopy || newCopy === content}
        fullWidth
        onPress={() => {
          // Need to add a timeout so that the click event doesn't bleed through to the buttons on the next screen
          setTimeout(() => {
            dispatch({ type: ArticlePostPreviewActionTypes.SET_CONTENT, payload: newCopy })
            dispatch({ type: ArticlePostPreviewActionTypes.SET_CHANGING_COPY, payload: false })
            persistChanges()
          }, 50)
        }}
      >
        Swap with current copy
      </Button>
    </div>
  )
}
